import React from "react";
import BadgeBase from "../BadgeBase";
import { resolveStatusBadge } from "./config";

const StatusBadge = ({ value, status, label, tone, size = "md", sx, ...props }) => {
  const resolved = resolveStatusBadge(value ?? status);

  return (
    <BadgeBase tone={tone || resolved.tone} size={size} sx={sx} {...props}>
      {label || resolved.label}
    </BadgeBase>
  );
};

export default StatusBadge;
